module.exports = __webpack_public_path__ + "img/14.35185e9e.png";